export default {
  lg: {
    padding: '10px 18px',
    fontSize: '14px',
    fontWeight: '700'
  },
  md: {
    padding: '8px 12px',
    fontSize: '12px',
    fontWeight: '600'
  },
  sm: {
    padding: '6px 8px',
    fontSize: '10px',
    fontWeight: '600'
  },
  uppercase: true,
  borderRadius: '60px'
}
